import axios from "./configs/axiosConfig";

export const getAdminDashbaordCardData = async () => {
  const url = `admindashboard/cardsdata`;
  return await axios.get(url);
};
